import { makeStyles, Toolbar, Typography } from "@material-ui/core";
import { useQuery } from "@redux-requests/react";
import { Formik } from "formik";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { BaseLayout, Header } from "../components";
import TextField from "../components/formik/TextField";
import { getExperts } from "../ducks/actions";
import * as types from "../ducks/types";
import { ExpertsGrid } from "../features/experts";
import { useQueryParams } from "../hooks";
import { ReactComponent as SpeakerSvg } from "../assets/icons/speaker.svg";

const useStyles = makeStyles(theme => ({
  root: {
    "& > *": {
      marginBottom: theme.spacing(3)
    }
  },
  filter: {
    marginLeft: theme.spacing(1),
    flexGrow: 0.2
  }
}));

const ExpertsPage = () => {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const [{ name }, mergeParams] = useQueryParams();

  useEffect(() => {
    dispatch(getExperts({ name }));
  }, [dispatch, name]);

  const {
    data: { data: experts },
    loading: expertsLoading
  } = useQuery({ type: types.GET_EXPERTS, defaultData: { data: [] } });

  const onSubmit = ({ name }) => {
    mergeParams({ name });
  };

  return (
    <BaseLayout className={classes.root}>
      <Header
        icon={SpeakerSvg}
        title={intl.formatMessage({
          id: "Pages.ExpertsPage.Experts",
          defaultMessage: "Invited Speakers"
        })}
      />
      <Formik initialValues={{ name: name || "" }} onSubmit={onSubmit}>
        <Toolbar>
          <Typography variant="subtitle1">
            <strong>
              {intl.formatMessage({
                id: "Pages.ExpertsPage.FilterBy",
                defaultMessage: "Filter by"
              })}
            </strong>
          </Typography>
          <TextField
            name="name"
            variant="outlined"
            label={intl.formatMessage({
              id: "Pages.ExpertsPage.Name",
              defaultMessage: "Name"
            })}
            className={classes.filter}
            submitOnChange
          />
        </Toolbar>
      </Formik>
      <ExpertsGrid loading={expertsLoading} experts={experts} />
    </BaseLayout>
  );
};

export default ExpertsPage;
